<template>
  <div class="popup">
    <div class="user">
      <img src="../../assets/user.png" alt="" />
      <p>{{ userName }}</p>
    </div>
    <ul class="user_actions">
      <li class="user_action">View Profile</li>
      <li class="user_action">Contact Support</li>
      <li class="user_action">Log Out</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PopUpMenu",
  props: {
    userName: String,
  },
};
</script>

<style scoped lang="scss">
.popup {
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 1.389vw;
  padding: 1.389vw;
  border-radius: 1rem;
  background: #f3f3f3;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
  position: absolute;
  right: 2.778vw;
  top: 2.778vw;
  .user {
    display: flex;
    gap: 1.389vw;
    align-items: center;
    img {
      width: 2.315vw;
      height: 2.315vw;
      border-radius: 50%;
    }
    p {
      color: #000;
      font-family: "DM Sans";
      font-size: 1.389vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.056vw;
    }
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 1.389vw;
    width: fit-content;
    li {
      color: #000;
      font-family: "DM Sans";
      font-size: 1.852vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.074vw;
      cursor: pointer;
    }
    li:nth-child(3) {
      color: var(--accent-colour);
    }
  }
}
</style>
